import React, { Fragment, useEffect, useState, forwardRef } from "react";
import { useAuth } from "../context/AuthContext";
import AsyncSelect from "react-select/async";

const UserSelection = forwardRef(({
  defaultValue,
  onSelected,
  placeholderText = "All Users",
  disabled = false,
}, ref) => {
  const { authAxios } = useAuth();
  const [selected, setSelected] = useState(null);

  const getLabel = (user) => {
    return user?.surname + ", " + user?.forename;
  };

  useEffect(() => {
    if (defaultValue?.id === null || defaultValue?.id === undefined) return;

    setSelected({ value: defaultValue, label: getLabel(defaultValue) });
  }, [defaultValue]);

  const searchUsers = async (search) => {
    try {
      var params = {};
      if (search !== null && search !== "") {
        params["search"] = search;
      }
      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: params,
      };

      const response = await authAxios().post(
        "/api/backoffice/users/all",
        null,
        config,
      );

      const data = response.data.map((user) => {
        return { value: user, label: getLabel(user) };
      });

      return data;
    } catch (error) {
      console.log("Error catch");
      console.log(error);
      console.log(error.stack);
    }
    return [];
  };

  const selectUser = (user) => {
    setSelected(user);
    onSelected(user?.value);
  };

  const promiseOptions = (inputValue) =>
    new Promise((resolve) => {
      setTimeout(() => {
        resolve(searchUsers(inputValue));
      }, 1000);
    });

  // Expose methods to the parent component via ref
  React.useImperativeHandle(ref, () => ({
    reset: () => {
      setSelected(null);
      onSelected(null);
    }
  }));

  return (
    <Fragment>
      <AsyncSelect
        className={"fs-input"}
        cacheOptions
        loadOptions={promiseOptions}
        defaultOptions={true}
        isClearable={true}
        onChange={(data) => {
          selectUser(data);
        }}
        value={selected}
        placeholder={placeholderText}
        isDisabled={disabled}
      />
    </Fragment>
  );
});

export default UserSelection;
